import { Text, Box, VStack } from '@chakra-ui/react'
import Footer from '../components/Footer'
import { Link } from 'react-router-dom'
import { Button } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

const ErrorPage = () => {
    const { t } = useTranslation()

  return (
    <>
        <Box
            bgGradient={'linear(to-tr, pink.100, orange.200)'}
            width={'100%'}
            position="relative"
            padding={'12vh 0vw'}
             >
                <VStack
                    width={{base:'90vw',md:'80vw'}}
                    margin={'auto'}
                  >
                    <Text
                        fontSize={'2xl'}
                        fontFamily={'heading'}
                        fontWeight={'bold'}
                        padding={'2vh 0'}
                        >{t('error.title')}</Text>
                        <VStack
                          bg={'rgba(255,255,255,0.5)'}
                          borderRadius={'10'}
                          w={'100%'}
                          minH={{base:'20vh', md:'40vh'}}
                          padding={'6vh 2vw'}>

                              <Text textAlign={'center'}>{t('error.body')}</Text>
                              <Link to={'/'}><Button>{t('error.home')}</Button></Link>
                        </VStack>

                </VStack>

        </Box>
        <Footer></Footer>

    </>
  )
}

export default ErrorPage
